module.exports = __webpack_public_path__ + "img/reset_password.17c006c3.png";